var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon TV boucher black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-TV-boucher-black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9580418,9 L10.1958042,9 C8.43811188,9 7,10.4171394 7,12.1491987 L7,31.0443909 C7,32.7764502 8.43811188,34.1935896 10.1958042,34.1935896 L21.3811188,34.1935896 L18.1853146,38.9173877 L18.1853146,40.491987 L30.9685314,40.491987 L30.9685314,38.9173877 L27.7727272,34.1935896 L38.9580418,34.1935896 C40.7157341,34.1935896 42.153846,32.7764502 42.153846,31.0443909 L42.153846,12.1491987 C42.153846,10.4171394 40.7157341,9 38.9580418,9 Z M38.9580418,27.8951922 L10.1958042,27.8951922 L10.1958042,12.1491987 L38.9580418,12.1491987 L38.9580418,27.8951922 Z",
    id: "Shape",
    fill: "#505050",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIconGrey);
export default __webpack_public_path__ + "static/media/tv-icon-grey.831562d5e36f0fb188b66e20440b00a9.svg";
export { ForwardRef as ReactComponent };